import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import API from '../utils/api';

export default function TomorrowPreviewCard({ childId }) {
  const [preview, setPreview] = useState(null);
  const [loading, setLoading] = useState(true);
  const navigate = useNavigate();

  useEffect(() => {
    if (!childId) return;
    API.get(`/stories/tonight/${childId}`)
      .then(res => setPreview(res.data.tonight))
      .catch(() => {})
      .finally(() => setLoading(false));
  }, [childId]);

  if (loading || !preview) return null;

  const handleGenerate = () => {
    const params = new URLSearchParams({
      childId,
      theme: preview.theme || '',
      surpriseMe: 'true',
    });
    navigate(`/dashboard/generate?${params.toString()}`);
  };

  return (
    <div className="mt-4 p-4 rounded-4"
      style={{ background: 'linear-gradient(135deg,#1a0a3d 0%,#2d1b69 100%)', border: '1px solid rgba(111,66,193,0.4)' }}>
      <div className="d-flex align-items-center gap-2 mb-2">
        <span style={{ fontSize: '18px' }}>🌙</span>
        <span className="fw-bold" style={{ color: '#e8d5ff', fontSize: '13px', fontFamily: "'Fredoka One',cursive" }}>
          Tomorrow Night's Story…
        </span>
      </div>

      {preview.theme && (
        <p style={{ color: '#b0a0d0', fontSize: '14px', margin: '0 0 12px', lineHeight: 1.5 }}>
          We're thinking about a <strong style={{ color: '#d4b8ff' }}>{preview.theme}</strong> adventure
          {preview.concept ? ` — ${preview.concept}` : '.'}
        </p>
      )}

      <button className="btn btn-sm rounded-pill"
        style={{ background: 'rgba(111,66,193,0.3)', color: '#e8d5ff', border: '1px solid rgba(111,66,193,0.5)', fontSize: '13px' }}
        onClick={handleGenerate}>
        <i className="bi bi-stars me-1"></i>Generate it now
      </button>
    </div>
  );
}
